/* import __COLOCATED_TEMPLATE__ from './data.hbs'; */
/* RESPONSIBLE TEAM: team-standalone */

import Component from '@glimmer/component';
import { action } from '@ember/object';

interface Signature {
  Args: {
    openSection: string | null;
    setSection?: (section: string | null) => void;
  };
}

export default class StandaloneIntercomMessengerDeployData extends Component<Signature> {
  @action
  setSection(section: string | null) {
    this.args.setSection?.(section);
  }
}

declare module '@glint/environment-ember-loose/registry' {
  export default interface Registry {
    'Standalone::IntercomMessenger::Deploy::Data': typeof StandaloneIntercomMessengerDeployData;
    'standalone/intercom-messenger/deploy/data': typeof StandaloneIntercomMessengerDeployData;
  }
}
